import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsAssociation,
  UpdateNpsAssociation,
  FiltersNpsAssociations
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsAssociationResponse,
  ListNpsAssociationsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsAssociationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/associations'
  }

  async create(payload: CreateNpsAssociation): Promise<NpsAssociationResponse> {
    try {
      const response = await request.post<NpsAssociationResponse>(this.getCompletePath(), payload)
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar a associação.')
    }
  }

  async update(
    associationId: number,
    payload: UpdateNpsAssociation
  ): Promise<NpsAssociationResponse> {
    try {
      const response = await request.put<NpsAssociationResponse>(
        `${this.getCompletePath()}/${associationId}`,
        payload
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível atualizar a associação.')
    }
  }

  async getById(associationId: number): Promise<NpsAssociationResponse> {
    try {
      const response = await request.get<NpsAssociationResponse>(
        `${this.getCompletePath()}/${associationId}`
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar a associação.')
    }
  }

  async delete(associationId: number): Promise<void> {
    try {
      await request.delete(`${this.getCompletePath()}/${associationId}`)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível remover a associação.')
    }
  }

  async list(filters?: FiltersNpsAssociations): Promise<ListNpsAssociationsResponse> {
    try {
      const { data } = await request.get<ListNpsAssociationsResponse>(
        this.getCompletePath(),
        filters
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as associações.')
    }
  }
}
